import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ipNetworkingPress",
  "use": "ipNetworkingPress-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ipNetworkingPress\"><path d=\"M13.1 6.2c-.1-.2-.3-.3-.5-.5-.2-.1-.4-.2-.5-.3 0 0-.1 0-.1-.1-.2-.1-.4-.1-.6-.2h-.1c-.3-.1-.5-.1-.8-.1h-.2c-1.2.1-2.2.7-2.7 1.7l-.9-.5c.6-1 1.6-1.8 2.8-2.1-.8-.7-1.8-1.1-3-1.1C4 3 2 5 2 7.5S4 12 6.5 12h4c1.9 0 3.5-1.6 3.5-3.5 0-.9-.3-1.7-.9-2.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol